import { ComponentProps, useRef } from 'react';
import ReactECharts from 'echarts-for-react';

type SafeEChartsProps = ComponentProps<typeof ReactECharts>;

const hideTip = (chart?: any) => {
  if (!chart || chart.isDisposed?.()) return;
  try {
    chart.dispatchAction({ type: 'hideTip' });
    chart.dispatchAction({ type: 'downplay' });
    chart.dispatchAction({ type: 'updateAxisPointer', currTrigger: 'leave' });
  } catch {
    // Ignore hover cleanup errors after dispose.
  }
};

const SafeECharts = ({ option, onEvents, opts, onChartReady, ...rest }: SafeEChartsProps) => {
  const instanceRef = useRef<any>(null);
  const userClick = onEvents?.click;

  return (
    <ReactECharts
      option={option}
      lazyUpdate
      opts={{ renderer: 'canvas', ...(opts || {}) }}
      onChartReady={chart => {
        instanceRef.current = chart;
        onChartReady?.(chart);
      }}
      onEvents={{
        ...(onEvents || {}),
        click: (params: any) => {
          hideTip(instanceRef.current);
          if (!userClick) return;
          window.setTimeout(() => {
            try {
              (userClick as (p: any) => void)(params);
            } catch {
              // Parent click handlers should not take down the chart.
            }
          }, 0);
        },
        globalout: () => hideTip(instanceRef.current),
      }}
      {...rest}
    />
  );
};

export default SafeECharts;
